import React from "react";
import "./RenewPolicy.css";
import addicon from "../../../Images/Refrence/Icon ionic-md-add.svg";

const AddRenewPolicy = () => {
    return (
        <>
            <div className="AdRenew_BOx">
                <div className="InAdition">
                    <span><img alt="" src={addicon} /></span>
                    <p>Add Policy</p>
                </div>
            </div>
        </>
    );
}
export default AddRenewPolicy;